// apps/web/src/routes/settings.tsx
import { NavLink, Outlet } from 'react-router-dom'
import { cn } from '@viecxanh/chat-ui/utils'

const SETTINGS_NAV = [
  { to: '/settings/working-hours', label: 'Giờ làm việc' },
  { to: '/settings/auto-reply', label: 'Tự động trả lời' },
  { to: '/settings/widget', label: 'Widget nhúng' },
]

export function SettingsPage() {
  return (
    <div className="flex h-full">
      <aside className="w-48 border-r bg-white py-4">
        <p className="px-4 text-xs font-semibold text-slate-400 uppercase mb-2">Cài đặt</p>
        {SETTINGS_NAV.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'block px-4 py-2 text-sm hover:bg-slate-50',
                isActive ? 'text-brand font-medium bg-green-50' : 'text-slate-700',
              )
            }
          >
            {label}
          </NavLink>
        ))}
      </aside>
      <div className="flex-1 overflow-y-auto p-6">
        <Outlet />
      </div>
    </div>
  )
}
